import { Stack, Text } from "@chakra-ui/react";
import { Alert, Checkbox } from "barte-design-system";

export const CHARGE_DOMAIN_LABEL = "Transação";

interface ChargeDomainFieldProps {
  isVersion2: boolean;
  isChecked: boolean;
  onChange: (checked: boolean) => void;
}

export const ChargeDomainField = ({
  isVersion2,
  isChecked,
  onChange,
}: ChargeDomainFieldProps) => {
  return (
    <Stack spacing={2}>
      <Checkbox
        name="charge"
        label={CHARGE_DOMAIN_LABEL}
        checked={isVersion2 && isChecked}
        disabled={!isVersion2}
        onChange={onChange}
      />
      {!isVersion2 && (
        <Text color="gray.400" fontSize=".8rem">
          {`${CHARGE_DOMAIN_LABEL} está disponível apenas na versão 2.0.`}
        </Text>
      )}
      {isVersion2 && isChecked && (
        <Alert
          variant="info"
          showCloseButton={false}
          title={`Sobre os eventos de ${CHARGE_DOMAIN_LABEL}`}
          description={`Ao ativar ${CHARGE_DOMAIN_LABEL}, você recebe os três eventos do domínio — charge.refund.processing, charge.refund.succeeded e charge.refund.failed — sem seleção individual por evento. A cobertura é por cobrança e está em liberação gradual: somente estornos de cobranças processadas no novo fluxo de pagamentos geram eventos, então é esperado não receber notificações para parte dos estornos durante esse período.`}
        />
      )}
    </Stack>
  );
};
